var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',{class:['page-title', _vm.titleClass]},[_vm._v(_vm._s(_vm.title))]),_c('p',{class:['page-subtitle', _vm.subtitleClass]},[_vm._t("default",[_vm._v(_vm._s(_vm.subtitle))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }